import o from"../internals/collection.js";import t from"../internals/collection-strong.js";var r=o,e=t;r("Map",function(n){return function(){return n(this,arguments.length?arguments[0]:void 0)}},e);
